/* eslint-disable react/destructuring-assignment */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { withTranslation } from 'react-i18next';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import Icon from '@mdi/react';
import { mdiDotsVertical } from '@mdi/js';
import { v4 as uuid } from 'uuid';
import ReactRouterPropTypes from 'react-router-prop-types';
import PopoverBottom from '../../../shared/components/UI/Tooltips/PopoverBottom';
import { convertDateToHourStr } from '../../../shared/utils/smartutils';
import MemoBox from '../../Memo/components/MemoBox';

const WeekCalendar = (props) => {
  const {
    events,
    memoBoxes,
    startHours,
    startMinutes,
    finalHours,
    finalMinutes,
    defaultDateWeek,
    history,
  } = props;

  const createTodayByHoursAndMinutes = (hours, minutes) => {
    return new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDay(),
      hours,
      minutes
    );
  };

  const navigationToWithParams = (route, params) => {
    history.push(route, params);
  };

  const content = (type, summary) => {
    switch (type) {
      case 'OCCU':
        return summary.occurrence > 0 ? summary.occurrence : '';
      case 'AUTH':
        return summary.diary > 0 ? summary.diary : '';
      case 'ACTI':
        return summary.exam > 0 ? summary.exam : '';
      default:
        return '';
    }
  };

  const CustomHeader = (values) => {
    const { label } = values;
    const [day, dayOfWeek] = label.split(' ');
    return (
      <>
        <span>{day}</span>
        <span>{dayOfWeek}</span>
      </>
    );
  };
  const CustomEvent = (values) => {
    if (values) {
      const { start, room, subject, schoolClass, begin, summary } =
        values.event;
      return (
        <div className="card-content">
          <div className="info">
            <div className="hour-field">
              <span>{convertDateToHourStr(new Date(start))}</span>|
              <span className="text-ellipsis tooltip-test" title={room.name}>
                {room.name}
              </span>
            </div>
            <span className="text-ellipsis tooltip-test" title={subject.name}>
              {subject.name}
            </span>
            <span
              className="text-ellipsis tooltip-test"
              title={schoolClass.name}
            >
              {schoolClass.name}
            </span>
          </div>
          <div id={`more-icon-${begin}`} className="more">
            <Icon path={mdiDotsVertical} size={1} />
          </div>
          <PopoverBottom targetId={`more-icon-${begin}`} placement="right">
            <div className="memo-boxes-content-popover">
              {[...memoBoxes]
                .filter((memoItem) => memoItem.more)
                .map((memoItem) => {
                  return (
                    <button
                      type="button"
                      className="inbox__list-button text-ellipsis"
                      key={uuid()}
                      onClick={() =>
                        navigationToWithParams(memoItem.route, values)
                      }
                    >
                      <div className="popover-inline">
                        <div className="popover-inline-quantity">
                          {content(memoItem.type, summary)}
                        </div>
                        <MemoBox title={memoItem.title}>
                          {memoItem.icon}
                        </MemoBox>
                      </div>
                    </button>
                  );
                })}
            </div>
          </PopoverBottom>
        </div>
      );
    }
    return null;
  };

  const eventStyleGetter = (event) => {
    const { color } = event;
    const style = {
      backgroundColor: color,
      border: 'none',
    };
    return {
      style,
    };
  };

  return (
    <Calendar
      localizer={dateFnsLocalizer({
        format,
        parse,
        startOfWeek,
        getDay,
        locales: {
          'pt-BR': ptBR,
        },
      })}
      culture="pt-BR"
      formats={{ eventTimeRangeFormat: () => null }}
      components={{
        toolbar: () => <></>,
        week: {
          header: CustomHeader,
        },
        event: CustomEvent,
      }}
      events={events}
      onNavigate={() => {}}
      onView={() => {}}
      eventPropGetter={eventStyleGetter}
      step={30}
      view="week"
      views={['week']}
      date={defaultDateWeek}
      defaultDate={new Date()}
      min={createTodayByHoursAndMinutes(startHours, startMinutes)}
      max={createTodayByHoursAndMinutes(finalHours, finalMinutes)}
    />
  );
};

WeekCalendar.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  memoBoxes: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.element,
      title: PropTypes.string,
      link: PropTypes.string,
      more: PropTypes.bool,
    })
  ).isRequired,
  startHours: PropTypes.string,
  startMinutes: PropTypes.string,
  finalHours: PropTypes.string,
  finalMinutes: PropTypes.string,
  defaultDateWeek: PropTypes.shape(PropTypes.shape),
  history: ReactRouterPropTypes.history.isRequired,
};

WeekCalendar.defaultProps = {
  events: [],
  startHours: '00',
  startMinutes: '00',
  finalHours: '23',
  finalMinutes: '00',
  defaultDateWeek: new Date(),
};

export default withTranslation('common')(memo(WeekCalendar));
